const route = (resolve) => ({
  async: ['$q', function ($q) {
    const defer = $q.defer();

    resolve(defer.resolve);

    return defer.promise;
  }]
});

export default app => {
  const $inject = ['$urlRouterProvider', '$stateProvider'];

  const LbRoutes = function ($urlRouterProvider, $stateProvider) {

    $urlRouterProvider.otherwise(($injector) => {
      const $state = $injector.get('$state');
      $state.go('app.error', {}, { location: false });
    });

    $stateProvider
      .state('authenticate', {
        url: '/authenticate',
        template: '<lb-authenticate></lb-authenticate>',
        resolve: route(callback =>
          require.ensure([], () => {
              const lbAuthenticate = require('../components/lbAuthenticate/lbAuthenticate').name;
              callback(app.register(lbAuthenticate))
            }
          )
        ),
        params: {
          isPublic: true,
          pageTitle: 'Authenticate',
          bodyClass: 'bg-login'
        }
      })

      .state('landing', {
        abstract: true,
        template: '<ui-view></ui-view>',
        params: {
          isPublic: true
        },
        onEnter: ['authService', (authService) => {
          sessionStorage.clear();
        }],
      })

      .state('landing.login', {
        url: '/login',
        template: '<lb-login></lb-login>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbLogin = require('../components/lbLogin').name;
            callback(app.register(lbLogin));
          })
        ),
        params: {
          pageTitle: 'Login',
          bodyClass: 'bg-login'
        }
      })

      .state('deeplink', {
        url: '/deep-link',
        template: '<lb-deep-link></lb-deep-link>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbDeepLink = require('../components/lbDeepLink').name;
            callback(app.register(lbDeepLink));
          })
        ),
        params: {
          isPublic: true,
        }
      })

      .state('mobileauth', {
        url: '/mobile-auth',
        template: '<lb-mobile-auth></lb-mobile-auth>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbMobileAuth = require('../components/lbMobileAuth').name;
            callback(app.register(lbMobileAuth));
          })
        ),
        params: {
          isPublic: true,
        }
      })

      .state('loggedout', {
        url: '/logged-out',
        template: '<lb-logged-out></lb-logged-out>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbLoggedOut = require('../components/lbLoggedOut').name;
            callback(app.register(lbLoggedOut));
          })
        ),
        params: {
          isPublic: true,
        }
      })

      .state('app.error', {
        url: '/error',
        template: '<lb-error-screen></lb-error-screen>',
        resolve: route(callback =>
          require.ensure([], () => {
              const lbErrorScreen = require('../components/lbErrorScreen').name;
              callback(app.register(lbErrorScreen))
            }
          )
        ),
        params: {
          pageTitle: 'Page not found',
          bodyClass: 'bg-error',
          prev: null
        }
      })

      .state('app.home.search', {
        url: '/search',
        template: '<lb-home-search></lb-home-search>',
        resolve: route((callback) =>
          require.ensure([], () => {
            const component = require('../components/lbHomeSearch').name;
            callback(app.register(component))
          })
        ),

        params: {
          pageTitle: 'New Search',
          bodyClass: 'bg-search'
        }
      })

      .state('app.booking.error', {
        url: '/booking-error',
        template: '<lb-nav></lb-nav><lb-booking-error></lb-booking-error>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbBookingError = require('../components/lbBookingError').name;
            callback(app.register(lbBookingError))
          })
        ),
        params: {
          pageTitle: 'Booking Error',
        }
      })  

      .state('app.booking.change', {
        abstract: true,
        template: '<ui-view></ui-view>'
      })

      .state('app.booking.change.flights', {
        url: '/manage-bookings/flights',
        template: '<lb-search-results search-type="\'Travel\'"></lb-search-results>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbSearchResults = require('../components/lbSearchResults').name;
            callback(app.register(lbSearchResults))
          })
        ),
        params: {
          pageTitle: 'Manage Bookings - change flights results',
          bodyClass: 'bg-flights',
          searchRequired: true
        }
      })

      .state('app.booking.change.hotels', {
        url: '/manage-bookings/hotels/{hotelId}',
        template: '<lb-search-results search-type="\'Hotels\'"></lb-search-results>',
        resolve: route(callback =>
          require.ensure([], () => {
            const lbSearchResults = require('../components/lbSearchResults').name;
            callback(app.register(lbSearchResults))
          })
        ),
        params: {
          pageTitle: 'Manage Bookings - change hotels results',
          bodyClass: 'bg-hotels',
          searchRequired: true
        }
      })

      .state('app.change', {
        url: '',
        abstract: true,
        template: '<lb-home></lb-home>',
        resolve: Object.assign({}, route((callback) =>
          require.ensure([], () => {
            const lbHome = require('../components/lbHome').name;
            callback(app.register(lbHome))
          })
        ))
      })

      .state('app.change.booking', {
        url: '/manage-bookings/{pnr:[0-9A-Z]{6}}/change',
        template: '<lb-change-booking></lb-change-booking>',
        resolve: route(callback =>
          require.ensure([], () => {
              const component = require('../components/lbChangeBooking').name;
              callback(app.register(component))
            }
          )
        ),
        params: {
          pageTitle: 'Change Booking',
        }
      })

      .state('app.change.sector', {
        url: '/manage-bookings/{pnr:[0-9A-Z]{6}}/change/{sector}',
        template: '<lb-change-booking-wizard></lb-change-booking-wizard>',
        resolve: route(callback =>
          require.ensure([], () => {
              const component = require('../components/lbChangeBookingWizard').name;
              callback(app.register(component))
            }
          )
        ),
        params: {
          pageTitle: 'Change Booking',
        }
      })

      .state('app.change.payment', {
        url: '/manage-bookings/change/payment',
        template: '<lb-change-payment></lb-change-payment>',
        resolve: Object.assign({}, route((callback) =>
          require.ensure([], () => {
            const component = require('../components/lbChangePayment').name;
            callback(app.register(component));
          })
        ), {
          hasItineraryId: ['$q', ($q) => {
            const deferred = $q.defer();

            const itineraryId = sessionStorage.getItem('change:itineraryId');
            if (itineraryId) {
              deferred.resolve(itineraryId);
            } else {
              deferred.reject();
            }

            return deferred.promise;
          }]
        }),
        params: {
          pageTitle: 'Changed booking payment',
        }
      })

      // .state('app.home.slipstream', {
      //   url: '/slipstream',
      //   template: '<lb-slipstream></lb-slipstream>',
      //   resolve: route(callback =>
      //     require.ensure([], () => {
      //         const component = require('../components/lbSlipstream').name;
      //         callback(app.register(component))
      //       }
      //     )
      //   ),
      //   params: {
      //     pageTitle: 'Slipstream'
      //   }
      // });
  };

  LbRoutes.$inject = $inject;

  return LbRoutes;
};



// WEBPACK FOOTER //
// ./src/routes/routes.lb.js